import React, { forwardRef, memo } from "react"
import PropTypes from "prop-types"
import CustomTurnstile from "../Turnstile/CustomTurnstile"

const RecaptchaWrapper = forwardRef(function RecaptchaWrapper(
  {
    onRecaptchaChange,
    onRecaptchaExpire,
    formSubmitted,
    size = "invisible",
    theme = "auto",
    action,
    siteKey,
  },
  ref
) {
  const key =
    siteKey ||
    process.env.GATSBY_RECAPTCHA_KEY
  return (
    <CustomTurnstile
      ref={ref}
      siteKey={key}
      onTokenChange={onRecaptchaChange}
      onTokenExpire={onRecaptchaExpire}
      formSubmitted={formSubmitted}
      size={size}
      theme={theme}
      action={action}
    />
  )
})

RecaptchaWrapper.propTypes = {
  onRecaptchaChange: PropTypes.func,
  onRecaptchaExpire: PropTypes.func,
  formSubmitted: PropTypes.bool,
  size: PropTypes.oneOf(["normal", "compact", "flexible", "invisible"]),
  theme: PropTypes.oneOf(["light", "dark", "auto"]),
  action: PropTypes.string,
  siteKey: PropTypes.string,
}

export default memo(RecaptchaWrapper)
